type ObjectWithKeys = Record<string, any>;

export default function validateObject<T extends ObjectWithKeys>(
  obj: T,
  keys: (keyof T)[]
): boolean {
  return keys.every(key => obj[key] !== undefined && obj[key] !== null && obj[key] !== '');
}
